module.exports = __webpack_public_path__ + "static/media/DiSC_Icon.90c54746.png";